import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getClinicians = async (params) => {
    const res = await api.get("/Patient/Clinicians", {
        params,
    });

    return res.data;
};

export const useClinicians = (params) => {
    return useQuery({
        queryKey: ["clinicians", params],
        queryFn: () => getClinicians(params),
        retry: 3,
        staleTime: 1000 * 60,
    });
};

export const getClinician = async (id) => {
    const res = await api.get(`/Patient/Clinicians/${id}`);

    return res.data;
};

export const useClinician = (id) => {
    return useQuery({
        queryKey: ["clinician", id],
        queryFn: () => getClinician(id),
        enabled: !!id,
        retry: 3,
        staleTime: Infinity,
    });
};
